import React from "react";
import { FilterBar, Switch } from "@sscs/ui";
import { CveFilter, VulnerabilitySeverityFilter, VulnerabilityTagFilter, } from "../../../common";
import { useReportSelector } from "../../../hooks";
import { isFilteredByLink } from "../../../utils";
import { selectFilteredByLink } from "../../store/vulnerabilitiesSlice";
import { initFilter } from "../utils";
import styles from "./filter.module.scss";
const Filter = ({ filter, cveList, onChange, }) => {
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "cve",
                control: (React.createElement(CveFilter, { value: filter.cve, cveList: cveList, className: styles["cve-filter"], onChange: (value) => onChange({
                        ...filter,
                        cve: value === "" ? null : value,
                    }), "data-filtered-by-link": isFilteredByLink(filter, initFilter, "cve", filteredByLink) })),
            },
            {
                id: "exploit",
                width: "300px",
                control: (React.createElement(VulnerabilityTagFilter, { value: filter.exploit, onChange: (value) => onChange({ ...filter, exploit: value }), className: styles["exploit-filter"], "data-filtered-by-link": filter.exploit.toSorted().toString() !==
                        initFilter.exploit.toSorted().toString() && filteredByLink })),
            },
            {
                id: "severity",
                width: "200px",
                control: (React.createElement(VulnerabilitySeverityFilter, { value: filter.cvss_score_severity, onChange: (value) => {
                        onChange({
                            ...filter,
                            cvss_score_severity: value,
                        });
                    }, className: styles["severity-filter"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "cvss_score_severity", filteredByLink) })),
            },
            {
                id: "hide-triaged",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter vulnerabilities", label: "Hide triaged", checked: filter.hideTriaged, onChange: (event) => onChange({ ...filter, hideTriaged: event.target.checked }) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map